import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "./components/Navbar";
import SuccessPage from "./components/SuccessPage";
import DownloadFilter from "./components/DownloadFilter";
import MultiStepForm from "./components/MultiStepForm";
import Facebook from "./tracking/Facebook";
import NotFound from "./pages/notFound";


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <Facebook />
        <Routes>
          <Route path="/" element={<MultiStepForm />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/downloads" element={<DownloadFilter />} />
          <Route path="*" element={<NotFound />} />

        </Routes>
    <ChatIframe src="https://bot.serviceschoolhouse.com/99472f4d-bf99-4804-8455-36a515979678"/>
      </div>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;



const ChatIframe = ({ src, width = 350, height = 500 }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => setIsOpen(prev => !prev);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end space-y-3">
      {/* Chat Iframe Panel */}
      {isOpen?<div
        className={`bg-white rounded-xl shadow-2xl overflow-hidden transition-all duration-300 ${
          isOpen ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        style={{ width: `${width}px`, height: `${height}px` }}
      >
         <button
        onClick={toggleChat}
        className="w-full h-14 flex items-center justify-end float-right bg-gradient-to-br from-indigo-500 to-purple-500 text-red-500 text-2xl rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
        aria-label="Toggle Chat"
      >
        {isOpen ? '✖' : '💬'}
        
      </button>
        <iframe
          src={src}
          title="Live Chat"
          className="w-full h-full border-0"
        />
      </div>:null
}
      {/* Toggle Button */}
      <button
        onClick={toggleChat}
        className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-indigo-500 to-purple-500 text-white text-2xl rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
        aria-label="Toggle Chat"
      >
        {isOpen ? '✖' : '💬'}
        opeeeen
      </button>
    </div>
  );
};

// export default ChatIframe;